import { useRef } from 'react';

/**
 * Custom hook to manage scroll container refs for different sections
 *
 * @returns {Object} Object containing refs for each scrollable section
 */
const useScrollRefs = () => {
  const eventsForYouRef = useRef(null);
  const crewHighlightsRef = useRef(null);
  const trendingRef = useRef(null);
  const linkUpsRef = useRef(null);
  const crewsRef = useRef(null);

  return {
    eventsForYouRef,
    crewHighlightsRef,
    trendingRef,
    linkUpsRef,
    crewsRef,
  };
};

export default useScrollRefs;
